/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { ENVIRONMENT_CONFIG, Environment } from '@common/environment-shared';
import { Injectable, inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { removeIdTokenFromSessionStorage } from './storage/storage';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly oAuthService = inject(OAuthService);
  private readonly envConfig = inject<Environment>(ENVIRONMENT_CONFIG);

  public hasNoValidToken(): boolean {
    return !(this.oAuthService.hasValidAccessToken() && this.oAuthService.hasValidIdToken());
  }

  public logout(postLogoutRedirectUri?: string): void {
    if (postLogoutRedirectUri) {
      this.oAuthService.logOut({
        post_logout_redirect_uri: postLogoutRedirectUri,
        client_id: this.envConfig.clientId,
      });
      return;
    }
    this.oAuthService.logOut();
  }

  public logoutWithConfirmation(): void {
    removeIdTokenFromSessionStorage();

    const customParameters: object = { client_id: this.envConfig.clientId };
    this.oAuthService.logOut(customParameters);
  }
}
